const LoginEventCategory: string = 'center_login'
const LoginEventSignInAction: string = 'sign_in'

export default LoginEventCategory
export { LoginEventCategory, LoginEventSignInAction }
